import { usePermissionStore } from '../store/usePermissionStore';

/**
 * Hook to check if user has a specific permission
 */
export const useHasPermission = (resource: string, action: string): boolean => {
  const hasPermission = usePermissionStore((state) => state.hasPermission);
  return hasPermission(resource, action);
};

/**
 * Hook to check if user has any of the specified permissions
 */
export const useHasAnyPermission = (resource: string, actions: string[]): boolean => {
  const hasAnyPermission = usePermissionStore((state) => state.hasAnyPermission);
  return hasAnyPermission(resource, actions);
};

/**
 * Hook to check if user can access a resource (has any permission for it)
 */
export const useCanAccessResource = (resource: string): boolean => {
  const canAccessResource = usePermissionStore((state) => state.canAccessResource);
  return canAccessResource(resource);
};

/**
 * Hook to check if user is main admin
 */
export const useIsMainAdmin = (): boolean => {
  const isMainAdmin = usePermissionStore((state) => state.isMainAdmin);
  return isMainAdmin;
};

/**
 * Resource name mapping for menu items
 */
export const RESOURCE_MAP: Record<string, string> = {
  '/families': 'families',
  '/family-members': 'family-members',
  '/unit': 'units',
  '/events': 'events',
  '/news': 'news',
  '/history': 'history',
  '/hero-images': 'hero-images',
};

/**
 * Get resource name from path
 */
export const getResourceFromPath = (path: string): string | null => {
  return RESOURCE_MAP[path] || null;
};

